import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { CustomOutlinedDisabledTextField } from "../../../../partials/content/Forms";
import { onPreventEnterSubmitting, setObject } from "../../../../utils/utils";
import { DialogActions } from "@material-ui/core";
import { Card } from "react-bootstrap";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchCurrency from "../../setup/finance/searchCurrency";
import { saveSalesCard } from "../../../../services/crm/salesCardService";
import SearchCustomer from "../../sales/customers/searchCustomer";
import SearchLead from "../leads/searchLead";
import Swal from "sweetalert2";
import { getSalesLifeCycleStatus } from "../../../../services/setup/crm/crmSetupService";
import SearchUser from "../../users/users/searchUser";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import store from "../../../../store/store";
import { DateTime } from "luxon";
import {
  FormSelectField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";

const SalesCardForm = ({
  salesCard,
  visit = { ID: 0 },
  onConfirmSave,
  onCloseDialog,
}) => {
  const [openSearchCurrency, setOpenSearchCurrency] = useState(false);
  const [openSearchLead, setOpenSearchLead] = useState(false);
  const [openSearchCustomer, setOpenSearchCustomer] = useState(false);
  const [openSearchSales, setOpenSearchSales] = useState(false);
  const [slcStatus, setSlcStatus] = useState([]);
  const { companyProfile, socket } = useGlobalData();
  useEffect(() => {
    const { auth } = store.getState();

    if (salesCard && salesCard.ID > 0) {
      setObject(socket, "lock", salesCard.ID, "SLCL", auth.user)
        .then((response) => {})
        .catch((error) => {
          onCloseDialog();
        });
    }

    getSlcStatusData();

    return () => {
      if (salesCard && salesCard.ID > 0) {
        setObject(socket, "release", salesCard.ID, "SLCL", auth.user);
      }
    };
  }, [salesCard]);

  let salesCardData = {
    ID: 0,
    title: "",
    clientType: 1,
    customerID: 0,
    customerName: "",
    leadID: 0,
    leadName: "",
    assignedToMe: false,
    assignedUserID: "",
    assignedUserName: "",
    visitID: visit.ID,
    statusID: 0,
    statusName: "",
    description: "",
    currencyID: companyProfile.currency.ID,
    currencyCode: companyProfile.currency.currencyCode,
    estimatedValue: 0,
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  };

  if (visit.ID > 0) {
    if (visit.customerID > 0) {
      salesCardData.clientType = 2;
      salesCardData.customerID = visit.customerID;
      salesCardData.customerName = visit.customer.customerName;
    } else if (visit.leadID > 0) {
      salesCardData.clientType = 1;
      salesCardData.leadID = visit.leadID;
      salesCardData.leadName =
        visit.lead.leadName + " " + visit.lead.contactName;
    }
  }

  if (salesCard && salesCard.ID > 0) {
    salesCardData = {
      ID: salesCard.ID,
      title: salesCard.title,
      clientType: salesCard.customer.ID > 0 ? 2 : 1,
      customerID: salesCard.customer.ID,
      customerName: salesCard.customer.customerName,
      leadID: salesCard.lead.ID,
      leadName: salesCard.lead.leadName + " " + salesCard.lead.contactName,
      assignedUserID: salesCard.assignedUserID,
      assignedUserName: salesCard.assignedUserName,
      statusID: salesCard.statusID,
      statusName: salesCard.slcStatus.statusName,
      description: salesCard.description,
      currencyID: salesCard.currencyID,
      currencyCode: salesCard.currency.currencyCode,
      estimatedValue: salesCard.estimatedValue,
      CreatedAt: salesCard.CreatedAt,
      UpdatedAt: salesCard.UpdatedAt,
      createdBy: salesCard.createdBy,
      updatedBy: salesCard.updatedBy,
    };
  }

  const salesCardSchema = yup.object().shape({
    ID: yup.number(),
    title: yup
      .string()
      .required("Sales Card Name is Required")
      .max(255, "Sales Card Name maximum characters is 255"),
    clientType: yup.number(),
    customerName: yup.string().when("clientType", {
      is: 2,
      then: yup.string().required("Customer is required"),
    }),
    leadName: yup.string().when("clientType", {
      is: 1,
      then: yup.string().required("Lead is required"),
    }),
    assignedUserName: yup.string().required("Assigned To is Required"),
    description: yup.string().required("Description is Required"),
    currencyID: yup.string(),
    currencyCode: yup.string(),
    estimatedValue: yup.number(),
    statusID: yup.number().min(1, "Sales Life Cycle Status is Required"),
  });
  return (
    <Formik
      initialValues={salesCardData}
      validationSchema={salesCardSchema}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        values.estimatedValue = parseFloat(values.estimatedValue);
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Sales Card ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveSalesCard(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onConfirmSave();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Card>
                <Card.Header>
                  <i className="fas fa-th-large"></i>
                  <span>
                    <strong>Sales Card Basic Info</strong>
                  </span>
                </Card.Header>
                <Card.Body>
                  <FormTextField label="Sales Card Name" name="title" />
                  {visit.ID === 0 ? (
                    <FormSelectField
                      label="Type"
                      name="clientType"
                      onSelectChange={(value) => {
                        if (value === 1) {
                          setFieldValue("leadID", 0);
                          setFieldValue("leadName", "");
                        } else if (value === 2) {
                          setFieldValue("customerID", 0);
                          setFieldValue("customerName", "");
                        }
                      }}
                      options={[
                        { label: "Lead", value: 1 },
                        { label: "Customer", value: 2 },
                      ]}
                    />
                  ) : (
                    <CustomOutlinedDisabledTextField
                      label="Client Type"
                      value={values.clientType === 1 ? "Lead" : "Customer"}
                    />
                  )}
                  {values.clientType === 2 ? (
                    <FormTextField
                      label="Customer Name"
                      name="customerName"
                      searchButton
                      readonly
                      onSearchClick={() => {
                        setOpenSearchCustomer(true);
                      }}
                    />
                  ) : (
                    <FormTextField
                      label="Lead Name"
                      name="leadName"
                      searchButton
                      readonly
                      onSearchClick={() => {
                        setOpenSearchLead(true);
                      }}
                    />
                  )}
                  <FormTextField
                    label="Assigned To"
                    name="assignedUserName"
                    searchButton
                    readonly
                    onSearchClick={() => {
                      setOpenSearchSales(true);
                    }}
                  />
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Currency"
                        name="currencyCode"
                        searchButton
                        readonly
                        onSearchClick={() => {
                          setOpenSearchCurrency(true);
                        }}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Estimated Value"
                        name="estimatedValue"
                        currencyField
                        currencyCode={values.currencyCode}
                      />
                    </div>
                  </div>
                  <FormSelectField
                    label="Sales Life Cycle Status"
                    name="statusID"
                    options={slcStatus}
                  />
                  <FormTextField
                    label="Description"
                    name="description"
                    multiline
                    minRows={5}
                  />
                </Card.Body>
              </Card>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-success btn-md btn-pill btn-bold"
              disabled={isSubmitting}
            >
              <i className="fas fa-save"></i>
              Save
            </button>
          </DialogActions>
          <DialogLayout
            open={openSearchCurrency}
            title="Search Currency"
            onCloseDialog={handleCloseSearchCurrency}
            maxWIdth="sm"
          >
            <SearchCurrency
              onSelectCurrency={(currency) => {
                setFieldValue("currencyID", currency.ID);
                setFieldValue("currencyCode", currency.currencyCode);
                handleCloseSearchCurrency();
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={handleCloseSearchCurrency}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchCustomer}
            title="Search Customer"
            onCloseDialog={handleCloseSearchCustomer}
            maxWIdth="lg"
          >
            <SearchCustomer
              onSelectCustomer={(customer) => {
                setFieldValue("customerID", customer.ID);
                setFieldValue("customerName", customer.customerName);
                setFieldValue("leadID", 0);
                setFieldValue("leadName", "");
                handleCloseSearchCustomer();
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={handleCloseSearchCustomer}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchLead}
            title="Search Lead"
            onCloseDialog={handleCloseSearchLead}
            maxWIdth="lg"
          >
            <SearchLead
              onSelectLead={(lead) => {
                setFieldValue("leadID", lead.ID);
                setFieldValue("leadName", lead.leadName);
                setFieldValue("customerID", 0);
                setFieldValue("customerName", "");
                handleCloseSearchLead();
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={handleCloseSearchLead}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchSales}
            title="Search Sales"
            onCloseDialog={handleCloseSearchSales}
            maxWIdth="lg"
          >
            <SearchUser
              salesUser="true"
              onSelectUser={(user) => {
                setFieldValue("assignedUserID", user.ID);
                setFieldValue(
                  "assignedUserName",
                  user.firstName + " " + user.lastName
                );
                handleCloseSearchSales();
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={handleCloseSearchSales}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
        </form>
      )}
    </Formik>
  );

  function handleCloseSearchSales() {
    setOpenSearchSales(false);
  }

  async function getSlcStatusData() {
    const response = await getSalesLifeCycleStatus();
    const { data } = response.data;
    setSlcStatus(data.selectOptions);
  }

  function handleCloseSearchCustomer() {
    setOpenSearchCustomer(false);
  }

  function handleCloseSearchLead() {
    setOpenSearchLead(false);
  }

  function handleCloseSearchCurrency() {
    setOpenSearchCurrency(false);
  }
};

export default SalesCardForm;
